import { useEffect, useState } from 'react';
import { ChunkLoadFailureReason, reportChunkLoadFailure } from '@lib/chunkLoad';

/**
 * Reports a chunk load failure (metric and log, once per chunk) and returns
 * why it failed.
 *
 * @returns the classification, or `undefined` while it is still being worked
 * out. A reporting error resolves to `UNKNOWN` so the view can still render.
 */
export const useChunkLoadFailure = (
  error: unknown,
): ChunkLoadFailureReason | undefined => {
  const [reason, setReason] = useState<ChunkLoadFailureReason>();

  useEffect(() => {
    let cancelled = false;
    reportChunkLoadFailure(error)
      .then((result) => {
        if (!cancelled) {
          setReason(result);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setReason(ChunkLoadFailureReason.UNKNOWN);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [error]);

  return reason;
};
